
import React from 'react';
import styles from './PreferinteCard.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoon, faMusic } from '@fortawesome/free-solid-svg-icons';

const PreferinteCard = ({ darkMode, soundEffects, handleDarkModeToggle, handleSoundEffectsToggle }) => {
  return (
    <div className={styles.preferinteCard}>
      <h4 className={styles.title + ' ' + styles.hideOnMobile}>Preferinte</h4>
      <div className={styles.prefRow}>
        <div className={styles.prefIcon} style={{ background: '#6c63ff' }}>
          <FontAwesomeIcon icon={faMoon} color="#fff" size="lg" />
        </div>
        <div className={styles.prefTextBlock}>
          <div className={styles.prefLabel}>Mod intunecat</div>
          <div className={styles.prefDesc}>Activeaza tema intunecata pentru a reduce oboseala ochilor</div>
        </div>
        <label className={styles.toggleSwitch}>
          <input type="checkbox" checked={darkMode} onChange={handleDarkModeToggle} />
          <span className={styles.toggleSlider}></span>
        </label>
      </div>
      <div className={styles.prefRow}>
        <div className={styles.prefIcon} style={{ background: '#ff5eae' }}>
          <FontAwesomeIcon icon={faMusic} color="#fff" size="lg" />
        </div>
        <div className={styles.prefTextBlock}>
          <div className={styles.prefLabel}>Efecte sonore</div>
          <div className={styles.prefDesc}>Reda sunete pentru notificari si actiuni</div>
        </div>
        <label className={styles.toggleSwitch}>
          <input type="checkbox" checked={soundEffects} onChange={handleSoundEffectsToggle} />
          <span className={styles.toggleSlider}></span>
        </label>
      </div>
    </div>
  );
};

export default PreferinteCard;
